import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const ParticipantVenueQuerySchema = PaginationRequestSchema.extend({
  teamId: z.string().optional(),
  venueId: z.string().optional(),
});
export type ParticipantVenueQueryDTO = z.infer<typeof ParticipantVenueQuerySchema>;

export const ParticipantVenueAssignmentResponseSchema = z.object({
  id: z.string(),
  teamId: z.string(),
  venueId: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type ParticipantVenueAssignmentResponseDTO = z.infer<
  typeof ParticipantVenueAssignmentResponseSchema
>;

export const ParticipantVenueAssignmentsPaginatedResponseSchema =
  PaginationResponseSchema(ParticipantVenueAssignmentResponseSchema);
export type ParticipantVenueAssignmentsPaginatedResponseDTO = z.infer<
  typeof ParticipantVenueAssignmentsPaginatedResponseSchema
>;

export const CreateParticipantVenueAssignmentRequestSchema = z.object({
  teamId: z.string().min(1, "El equipo es requerido"),
  venueId: z.string().nullable(),
});

export const UpdateParticipantVenueAssignmentRequestSchema =
  CreateParticipantVenueAssignmentRequestSchema.partial();

export type CreateParticipantVenueAssignmentRequestDTO = z.infer<
  typeof CreateParticipantVenueAssignmentRequestSchema
>;
export type UpdateParticipantVenueAssignmentRequestDTO = z.infer<
  typeof UpdateParticipantVenueAssignmentRequestSchema
>;
